function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $component, $helpers, Array, JSON, Object, String, builderScreen, stagedCohort) {
    var h = require("panel").h;
    var jade_mixins = {},
      $mixins = jade_mixins;
    jade_mixins['clause-condition-resource'] = function(options = {}) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        const {
          operatorDisabled
        } = options;;
        const clauseIdx = $helpers.getClauseIndex();
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'cohorts-clause-left-border': true
          },
        }));
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'cohorts-clause-label': true
          },
        }, [__vjadeSafeCode($helpers.getClauseLabel())]));
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'cohorts-clause-block': true,
            'cohorts-clause-resource-block': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'cohorts-clause-header': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat((clauseIdx === 0) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("span", {
                "class": {
                  'cohorts-clause-condition-label': true
                },
              }, [__vjadeSafeCode($helpers.getActionLabel())]));;
              return __jade_nodes
            }).call(this)) : ((function() {
              var __jade_nodes = [];
              const joinOperatorLabel = $helpers.getJoinOperatorLabel();
              __jade_nodes = __jade_nodes.concat((joinOperatorLabel) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("span", {
                  "class": {
                    'cohorts-clause-join-operator': true
                  },
                }, [__vjadeSafeCode(joinOperatorLabel)]));;
                return __jade_nodes
              }).call(this)) : undefined);;
              return __jade_nodes
            }).call(this)));
            __jade_nodes = __jade_nodes.concat(h("span", {
              "on": {
                click: !operatorDisabled && $helpers.toggleActionOperator
              },
              "class": Object.assign({}, {
                'cohorts-clause-toggle-operator-disabled': operatorDisabled
              }, {
                'cohorts-clause-toggle-operator': true
              }),
            }, [__vjadeSafeCode($helpers.getActionOperatorLabel())]));;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(h("div", (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "on": {
                click: $helpers.handleClickConditionLabel
              },
              "class": Object.assign({}, {
                'cohorts-clause-invalid': !$helpers.isResourceValid()
              }, {
                'cohorts-clause-clickable': true
              }),
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(($helpers.isBuilderOpen($helpers.BuilderType.Condition)) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(jade_mixins['autoresizing-builder-filter-input'].call(this, $helpers.getResourceLabel()));;
                return __jade_nodes
              }).call(this)) : ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat($helpers.getResourceLabel());
                __jade_nodes = __jade_nodes.concat((!$helpers.isResourceValid()) ? ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                    "attrs": __vjadeStringifyAttrsIfObj({
                      type: `error`,
                      'max-width': `200px`,
                      'placement': `bottom`
                    }),
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat($helpers.getInvalidResourceMessage());;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this)) : undefined);;
                return __jade_nodes
              }).call(this)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(jade_mixins['condition-builder'].call(this));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['clause-condition-header-builder'] = function(builderType) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'cohorts-clause-header': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'cohorts-clause-builder-container': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat((builderType === $helpers.BuilderType.ClauseOperator) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat($component.child(`cohorts-builder-pane-dropdown`, {
                attrs: {
                  'user-id': $attr(`user-id`),
                  open: $helpers.isBuilderOpen($helpers.BuilderType.ClauseOperator)
                },
                on: {
                  'selected-clause-operators': $helpers.selectedClauseOperators
                }
              }));;
              return __jade_nodes
            }).call(this)) : undefined);;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(h("div", {
            "on": {
              click: () => $helpers.toggleBuilder(builderType)
            },
            "class": {
              'cohorts-clause-header-button': true,
              'cohorts-condition-header-button': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'cohorts-clause-header-text': true
              },
            }, [__vjadeSafeCode($helpers.getClauseBuilderLabel())]));
            __jade_nodes = __jade_nodes.concat(h("svg-icon", {
              "attrs": __vjadeStringifyAttrsIfObj({
                icon: 'caret-down'
              }),
              "class": {
                'cohorts-clause-header-icon': true
              },
            }));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['autoresizing-builder-filter-input'] = function(placeholder) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("mp-autoresizing-input", {
          "attrs": __vjadeStringifyAttrsIfObj({
            'focus': true,
            'initial-width': 140,
            'input-style-overrides': JSON.stringify({
              'font-size': `16px`,
            }),
            'placeholder': placeholder,
          }),
          "on": {
            input: $helpers.searchFilterInput
          },
          "hook": {
            insert: $helpers.addBuilderKeydownProxyEl
          },
          "props": {
            value: builderScreen.searchFilter
          },
        }));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['condition-builder'] = function() {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'cohorts-clause-builder-container': true
          },
        }, (function() {
          var __jade_nodes = [];
          const handlers = {
            'save': () => $helpers.savePropertyFilterAndCloseBuilder($helpers.BuilderType.Condition),
            'selected-cohort': $helpers.selectedCohort,
            'selected-event': $helpers.selectedEvent,
            'selected-filter-operator': $helpers.selectedFilterOperator,
            'selected-filter-type': $helpers.selectedFilterType,
            'selected-property': $helpers.selectedProperty,
            'updated-filter-search': $helpers.updatedFilterSearch,
            'updated-filter-value': $helpers.updatedFilterValue,
          };
          __jade_nodes = __jade_nodes.concat($component.child(`cohorts-builder-pane-dropdown`, {
            attrs: {
              'user-id': $attr(`user-id`),
              open: $helpers.isBuilderOpen($helpers.BuilderType.Condition)
            },
            on: handlers
          }));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['property-filters-section'] = function() {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        const numPropertyFilters = $helpers.getNumPropertyFilters();
        __jade_nodes = __jade_nodes.concat((numPropertyFilters > 0) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'cohorts-clause-property-filter-separator-label': true,
              'cohorts-clause-where-label': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat("where");;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat((function() {
            var $$obj = (Array(numPropertyFilters).fill());
            var $$eachNodes;
            var $$iterated = false;
            if (Array.isArray($$obj)) {
              $$eachNodes = $$obj.reduce(function($$eachNodes, _, idx) {
                $$iterated = true;
                return $$eachNodes.concat((function() {
                  var __jade_nodes = [];
                  const lastFilterClause = idx === numPropertyFilters - 1;
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": Object.assign({}, {
                      'cohorts-clause-property-filter-spacer': lastFilterClause
                    }, {
                      'cohorts-clause-property-filter-clause-container': true
                    }),
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(jade_mixins['property-filter-clause'].call(this, idx));
                    __jade_nodes = __jade_nodes.concat((idx === 0) ? ((function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("div", {
                        "class": Object.assign({}, {
                          'cohorts-clause-property-filter-spacer': lastFilterClause
                        }, {
                          'cohorts-clause-property-filter-header-container': true
                        }),
                      }, (function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("div", {
                          "class": {
                            'cohorts-clause-header': true,
                            'cohorts-clause-property-filter-header': true
                          },
                        }, (function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat((numPropertyFilters > 1) ? ((function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("span", (function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat("Matches");;
                              return __jade_nodes
                            }).call(this).filter(Boolean)));
                            __jade_nodes = __jade_nodes.concat(h("span", {
                              "on": {
                                click: $helpers.togglePropertyFilterOperator
                              },
                              "class": {
                                'cohorts-clause-toggle-operator': true
                              },
                            }, [__vjadeSafeCode($helpers.getPropertyFilterOperator())]));
                            __jade_nodes = __jade_nodes.concat(h("span", (function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat("of the following");;
                              return __jade_nodes
                            }).call(this).filter(Boolean)));;
                            return __jade_nodes
                          }).call(this)) : undefined);;
                          return __jade_nodes
                        }).call(this).filter(Boolean)));;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));;
                      return __jade_nodes
                    }).call(this)) : undefined);;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));
                  __jade_nodes = __jade_nodes.concat((!lastFilterClause) ? ((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("div", {
                      "class": {
                        'cohorts-clause-property-filter-separator-label': true
                      },
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat((numPropertyFilters > 2 && idx !== numPropertyFilters - 2) ? ((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(`,`);;
                        return __jade_nodes
                      }).call(this)) : ((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat($helpers.getLogicalOperator());;
                        return __jade_nodes
                      }).call(this)));;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));;
                    return __jade_nodes
                  }).call(this)) : undefined);;
                  return __jade_nodes
                }).call(this));
              }, []);
            } else {
              $$eachNodes = [];
              for (var $$objKey in $$obj) {
                (function() {
                  var idx = $$objKey;
                  if ($$obj.hasOwnProperty(idx)) {
                    $$iterated = true;
                    var _ = $$obj[idx];
                    $$eachNodes = $$eachNodes.concat((function() {
                      var __jade_nodes = [];
                      const lastFilterClause = idx === numPropertyFilters - 1;
                      __jade_nodes = __jade_nodes.concat(h("div", {
                        "class": Object.assign({}, {
                          'cohorts-clause-property-filter-spacer': lastFilterClause
                        }, {
                          'cohorts-clause-property-filter-clause-container': true
                        }),
                      }, (function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(jade_mixins['property-filter-clause'].call(this, idx));
                        __jade_nodes = __jade_nodes.concat((idx === 0) ? ((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "class": Object.assign({}, {
                              'cohorts-clause-property-filter-spacer': lastFilterClause
                            }, {
                              'cohorts-clause-property-filter-header-container': true
                            }),
                          }, (function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("div", {
                              "class": {
                                'cohorts-clause-header': true,
                                'cohorts-clause-property-filter-header': true
                              },
                            }, (function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat((numPropertyFilters > 1) ? ((function() {
                                var __jade_nodes = [];
                                __jade_nodes = __jade_nodes.concat(h("span", (function() {
                                  var __jade_nodes = [];
                                  __jade_nodes = __jade_nodes.concat("Matches");;
                                  return __jade_nodes
                                }).call(this).filter(Boolean)));
                                __jade_nodes = __jade_nodes.concat(h("span", {
                                  "on": {
                                    click: $helpers.togglePropertyFilterOperator
                                  },
                                  "class": {
                                    'cohorts-clause-toggle-operator': true
                                  },
                                }, [__vjadeSafeCode($helpers.getPropertyFilterOperator())]));
                                __jade_nodes = __jade_nodes.concat(h("span", (function() {
                                  var __jade_nodes = [];
                                  __jade_nodes = __jade_nodes.concat("of the following");;
                                  return __jade_nodes
                                }).call(this).filter(Boolean)));;
                                return __jade_nodes
                              }).call(this)) : undefined);;
                              return __jade_nodes
                            }).call(this).filter(Boolean)));;
                            return __jade_nodes
                          }).call(this).filter(Boolean)));;
                          return __jade_nodes
                        }).call(this)) : undefined);;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));
                      __jade_nodes = __jade_nodes.concat((!lastFilterClause) ? ((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("div", {
                          "class": {
                            'cohorts-clause-property-filter-separator-label': true
                          },
                        }, (function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat((numPropertyFilters > 2 && idx !== numPropertyFilters - 2) ? ((function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(`,`);;
                            return __jade_nodes
                          }).call(this)) : ((function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat($helpers.getLogicalOperator());;
                            return __jade_nodes
                          }).call(this)));;
                          return __jade_nodes
                        }).call(this).filter(Boolean)));;
                        return __jade_nodes
                      }).call(this)) : undefined);;
                      return __jade_nodes
                    }).call(this));
                  }
                })();
              }
            }

            return $$eachNodes;
          })());;
          return __jade_nodes
        }).call(this)) : undefined);
        const propertyFilterOpen = $helpers.isBuilderOpen($helpers.BuilderType.PropertyFilter, {
          propertyFilterIdx: numPropertyFilters
        });
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'cohorts-clause-property-filter-builder': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(jade_mixins['property-filter-builder'].call(this, $helpers.BuilderType.PropertyFilter, numPropertyFilters));
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": Object.assign({}, {
              'cohorts-clause-filter-pane-open': propertyFilterOpen
            }, {
              'cohorts-clause-add-filter-control': true
            }),
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'cohorts-clause-search-icon-wrapper': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  icon: `search`
                }),
              }));;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("input", {
              "props": {
                autoFocus: true,
                placeholder: `Search`,
                type: `text`,
                value: builderScreen.searchFilter,
              },
              "on": {
                click: $helpers.clickedInput,
                input: $helpers.searchFilterInput,
              },
              "class": Object.assign({}, {
                'cohorts-clause-builder-search-active': propertyFilterOpen,
              }, {
                'remove-chrome-form-style': true,
                'cohorts-clause-builder-search-input': true
              }),
            }));
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'cohorts-clause-add-filter-button-container': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-button", {
                "on": {
                  click: $helpers.clickedAddFilter
                },
                "attrs": __vjadeStringifyAttrsIfObj({
                  theme: `tertiary`,
                  icon: `plus`,
                }),
                "class": {
                  'cohorts-clause-add-filter-button': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("Filter");;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(jade_mixins['clause-remove'].call(this, stagedCohort));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['property-filter-clause'] = function(propertyFilterIdx) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        const leftOffset = $helpers.getBuilderLeftOffset();
        __jade_nodes = __jade_nodes.concat(h("div", {
          "on": {
            click: ev => $helpers.handleClickPropertyFilter(ev, propertyFilterIdx)
          },
          "class": {
            'cohorts-clause-clickable': true,
            'cohorts-clause-property-filter': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat((propertyFilterIdx !== 0) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(jade_mixins['property-filter-builder'].call(this, $helpers.BuilderType.PropertyFilter, propertyFilterIdx, leftOffset));;
            return __jade_nodes
          }).call(this)) : undefined);
          __jade_nodes = __jade_nodes.concat(($helpers.isBuilderOpen($helpers.BuilderType.PropertyFilter, {
            propertyFilterIdx
          })) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(jade_mixins['autoresizing-builder-filter-input'].call(this, $helpers.getPropertyFilterLabel(propertyFilterIdx)));;
            return __jade_nodes
          }).call(this)) : ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat((function() {
                var $$obj = ($helpers.getPropertyFilterLabelParts(propertyFilterIdx));
                var $$eachNodes;
                var $$iterated = false;
                if (Array.isArray($$obj)) {
                  $$eachNodes = $$obj.reduce(function($$eachNodes, part, $index) {
                    $$iterated = true;
                    return $$eachNodes.concat((function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("span", {
                        "class": Object.assign({}, {
                          'cohorts-clause-highlight': part.isHighlighted
                        }, {
                          'cohorts-clause-property-filter-label-part': true
                        }),
                      }, [__vjadeSafeCode(part.label)]));;
                      return __jade_nodes
                    }).call(this));
                  }, []);
                } else {
                  $$eachNodes = [];
                  for (var $$objKey in $$obj) {
                    (function() {
                      var $index = $$objKey;
                      if ($$obj.hasOwnProperty($index)) {
                        $$iterated = true;
                        var part = $$obj[$index];
                        $$eachNodes = $$eachNodes.concat((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("span", {
                            "class": Object.assign({}, {
                              'cohorts-clause-highlight': part.isHighlighted
                            }, {
                              'cohorts-clause-property-filter-label-part': true
                            }),
                          }, [__vjadeSafeCode(part.label)]));;
                          return __jade_nodes
                        }).call(this));
                      }
                    })();
                  }
                }

                return $$eachNodes;
              })());;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)));
          __jade_nodes = __jade_nodes.concat(h("div", {
            "on": {
              click: ev => $helpers.removePropertyFilter(ev, propertyFilterIdx)
            },
            "class": {
              'cohorts-clause-remove-property-filter': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("svg-icon", {
              "attrs": __vjadeStringifyAttrsIfObj({
                icon: `x`
              }),
            }));;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat((propertyFilterIdx === 0) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(jade_mixins['property-filter-builder'].call(this, $helpers.BuilderType.PropertyFilter, propertyFilterIdx, leftOffset));;
            return __jade_nodes
          }).call(this)) : undefined);;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['property-filter-builder'] = function(builderType, propertyFilterIdx = 0, leftOffset = null) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "style": {
            left: leftOffset
          },
          "class": {
            'cohorts-clause-builder-container': true,
            'cohorts-clause-property-filter-builder-container': true
          },
        }, (function() {
          var __jade_nodes = [];
          const handlers = {
            'save': () => $helpers.savePropertyFilterAndCloseBuilder(builderType),
            'selected-filter-operator': $helpers.selectedFilterOperator,
            'selected-filter-type': $helpers.selectedFilterType,
            'selected-property': $helpers.selectedProperty,
            'updated-filter-search': $helpers.updatedFilterSearch,
            'updated-filter-value': $helpers.updatedFilterValue,
          };
          __jade_nodes = __jade_nodes.concat($component.child(`cohorts-builder-pane-dropdown`, {
            attrs: {
              open: $helpers.isBuilderOpen(builderType, {
                propertyFilterIdx
              }),
              'user-id': $attr(`user-id`)
            },
            on: handlers
          }));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['clause-remove'] = function(stagedCohort) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat((stagedCohort.numLiterals > 1 || stagedCohort.literals[0].clauses.length > 1) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-button", {
            "attrs": __vjadeStringifyAttrsIfObj({
              theme: `tertiary`,
              icon: `trashcan`,
              type: `destructive`,
            }),
            "on": {
              click: $helpers.removeClause,
            },
            "class": {
              'cohorts-clause-clause-remove': true
            },
          }));;
          return __jade_nodes
        }).call(this)) : undefined);;
        return __jade_nodes
      }).call(this);
    };

    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }

    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    const {
      BuilderType
    } = $helpers;
    const clauseIdx = $helpers.getClauseIndex();
    const isFunnelStep = $helpers.isFunnelStep();
    const shouldShowFrequencyBuilder = $helpers.shouldShowFrequencyBuilder();
    const canChangeDateRange = !isFunnelStep || clauseIdx === 0;
    return {
      value: (h("div", {
        "attrs": __vjadeStringifyAttrsIfObj({
          'data-clause-idx': clauseIdx
        }),
        "class": Object.assign({}, {
          'cohorts-clause-last-clause': $helpers.isLastClause()
        }, {
          'cohorts-clause-wrapper': true
        }),
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat((clauseIdx === 1) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(jade_mixins['clause-condition-header-builder'].call(this, BuilderType.ClauseOperator));
          __jade_nodes = __jade_nodes.concat(h("span", {
            "class": {
              'cohorts-clause-header': true
            },
          }, [__vjadeSafeCode($helpers.getClauseOperatorHeader())]));;
          return __jade_nodes
        }).call(this)) : undefined);
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'cohorts-clause-container': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(jade_mixins['clause-condition-resource'].call(this, {
            operatorDisabled: clauseIdx === 0 && isFunnelStep
          }));
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'cohorts-clause-block': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat((shouldShowFrequencyBuilder) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'cohorts-clause-header': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat((isFunnelStep) ? ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'cohorts-clause-header-text': true
                    },
                  }, [__vjadeSafeCode($helpers.getFrequencyOperator())]));;
                  return __jade_nodes
                }).call(this)) : ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'cohorts-clause-builder-container': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat($component.child(`cohorts-builder-pane-dropdown`, {
                      attrs: {
                        open: $helpers.isBuilderOpen(BuilderType.Frequency),
                        'user-id': $attr(`user-id`)
                      },
                      on: {
                        'selected-frequency-operator': $helpers.selectedFrequencyOperator
                      }
                    }));;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "on": {
                      click: () => $helpers.toggleBuilder(BuilderType.Frequency)
                    },
                    "class": {
                      'cohorts-clause-header-button': true,
                      'cohorts-frequency-header-button': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("div", {
                      "class": {
                        'cohorts-clause-header-text': true
                      },
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat($helpers.getFrequencyOperator());;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));
                    __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                      "attrs": __vjadeStringifyAttrsIfObj({
                        icon: 'caret-down'
                      }),
                    }));;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this)));;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat($component.child(`cohorts-clause-frequencies`, {
                attrs: {
                  'data-clause-idx': clauseIdx,
                  'data-literal-idx': $helpers.getLiteralIndex()
                }
              }));;
              return __jade_nodes
            }).call(this)) : undefined);
            __jade_nodes = __jade_nodes.concat((canChangeDateRange) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": Object.assign({}, {
                  'cohorts-clause-next-to-frequency-builder': shouldShowFrequencyBuilder
                }, {
                  'cohorts-clause-time-period-label': true
                }),
              }, [__vjadeSafeCode($helpers.sentenceConnector())]));;
              return __jade_nodes
            }).call(this)) : undefined);;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'cohorts-clause-block': true,
              'cohorts-clause-time-block': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'cohorts-clause-header': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("time");;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat((canChangeDateRange) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "on": {
                  click: $helpers.toggleDateBuilder
                },
                "class": {
                  'cohorts-clause-clickable': true,
                  'cohorts-clause-date': true
                },
              }, [__vjadeSafeCode($helpers.getDateRangeLabel())]));
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'cohorts-clause-builder-container': true
                },
              }, (function() {
                var __jade_nodes = [];
                const handlers = {
                  'selected-custom-range': $helpers.selectedCustomDateRange
                };
                __jade_nodes = __jade_nodes.concat($component.child(`cohorts-builder-pane-dropdown`, {
                  attrs: {
                    open: $helpers.isBuilderOpen(BuilderType.Date),
                    'user-id': $attr(`user-id`)
                  },
                  on: handlers
                }));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this)) : ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'cohorts-clause-time-period-label': true
                },
              }, [__vjadeSafeCode(`${$helpers.sentenceConnector()} ${$helpers.getDateRangeLabel()}`)]));;
              return __jade_nodes
            }).call(this)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(jade_mixins['property-filters-section'].call(this));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };

  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$component" in locals ? locals.$component : typeof $component !== "undefined" ? $component : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "Array" in locals ? locals.Array : typeof Array !== "undefined" ? Array : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined, "builderScreen" in locals ? locals.builderScreen : typeof builderScreen !== "undefined" ? builderScreen : undefined, "stagedCohort" in locals ? locals.stagedCohort : typeof stagedCohort !== "undefined" ? stagedCohort : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;